import { SVGProps } from 'react';

export const IconInfoFilled = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none'>
      <path
        d='M10.0003 18.3334C5.39795 18.3334 1.66699 14.6024 1.66699 10.0001C1.66699 5.39771 5.39795 1.66675 10.0003 1.66675C14.6027 1.66675 18.3337 5.39771 18.3337 10.0001C18.3337 14.6024 14.6027 18.3334 10.0003 18.3334ZM9.16699 9.16675V14.1667H10.8337V9.16675H9.16699ZM9.16699 5.83341V7.50008H10.8337V5.83341H9.16699Z'
        fill='currentColor'
      />
    </svg>
  );
};
